import React, { isValidElement } from 'react';
import styles from './card.module.scss';

interface ICardHeaderProps {
  title: string|number;
  subTitle?: string|number;
  optionsComponent?: React.ReactNode;
}
export const CardHeader = ({ title, subTitle='', optionsComponent }: ICardHeaderProps) => (
  <div className={styles.header}>
    <div>
      <p className={styles.headerTitle}>{title}</p>
      <p className={styles.headerSubtitle}>{subTitle}</p>
    </div>
    {optionsComponent ?? null}
  </div>
);

interface ICardContentProps {
  children: React.ReactNode;
}
export const CardContent = (props:ICardContentProps) => (
  <>{props.children}</>
);

interface ICardOptionsProps {
  children: React.ReactNode;
}
export const CardOptions = (props:ICardOptionsProps) => (
  <>{props.children}</>
);

interface ICardProps {
  children: any;
}
export const Card = (props:ICardProps) => {
  const childrenAsArray = React.Children.toArray(props.children);

  const header = childrenAsArray.find(
    (child) => isValidElement(child) && child.type === CardHeader,
  );
  const content = childrenAsArray.find(
    (child) => isValidElement(child) && child.type === CardContent,
  );
  const options = childrenAsArray.find(
    (child) => isValidElement(child) && child.type === CardOptions,
  );

  return (
    <div className={styles.card}>
      <div className={styles.cardHead}>
        {header && <div className={styles.headerContainer}>{header}</div>}
        {options && <div>{options}</div>}
      </div>
      {content && <div className={styles.content}>{content}</div>}
    </div>
  );
};
